(() => {
  if (window.__piurCartPageCartlyInstalled) return;
  window.__piurCartPageCartlyInstalled = true;

  function routesRoot() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root ? root : '/';
  }

  function productUrl() {
    const path = 'products/piur-recovery-essential-set?option_values=12233264300414%2C12233264497022%2C12233264628094';
    return `${routesRoot()}${path}`.replace(/\/{2,}/g, '/');
  }

  window.location.replace(productUrl());
})();
